import { Tables } from "@/lib/supabase/supabase_types_override";

export const createQuestionIdMapping = (
  surveyQuestions: Tables<"question">[]
) => {
  const templateToSurvey = new Map<string, string>();
  const surveyToTemplate = new Map<string, string>();

  surveyQuestions.forEach(surveyQ => {
    if (surveyQ.survey_bank_question_bank_ref_id) {
      templateToSurvey.set(surveyQ.survey_bank_question_bank_ref_id, surveyQ.id);
      surveyToTemplate.set(surveyQ.id, surveyQ.survey_bank_question_bank_ref_id);
    }
  });

  return { templateToSurvey, surveyToTemplate };
};